


































import Vue, { PropType } from 'vue';
import { RawLocation } from 'vue-router';

export default Vue.extend({
  name: 'VerticalNavigationItem',
  inheritAttrs: false,
  props: {
    to: { type: [String, Object] as PropType<RawLocation>, default: undefined },
    name: { type: String, default: undefined },
    badge: { type: [String, Number], default: undefined },
    badgeTitle: { type: String, default: 'New Items' },
    disabled: { type: Boolean, default: false },
  },
  computed: {
    toRoute(): RawLocation {
      if (this.to) return this.to;
      if (this.name) return { name: this.name };
      throw new Error('one of "to", "name" is required');
    },
  },
});
